import { useMutation } from "@tanstack/react-query";
import { createAdminFromInvite, ICreateAdminFromInvite } from "../actions/signupActions";

export const useCreateAdminFromInvite = () => {
  return useMutation({
    mutationKey: ["createAdminFromInvite"],
    mutationFn: (body: ICreateAdminFromInvite) => createAdminFromInvite(body),
  });
};
